// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Swiper from 'swiper/js/swiper';

const fragments = {
	SWIPER: '[data-fragment="CardProductOverviewSlider.swiper"]',
	PREV: '[data-fragment="CardProductOverviewSlider.prev"]',
	NEXT: '[data-fragment="CardProductOverviewSlider.next"]',
};

class CardProductOverviewSlider extends WebComponent {
	constructor (props) {
		super(props);
	}

	didMount() {
		const dataSliderPerView = this.element.getAttribute('data-slider-per-view');
		this.swiperElement = this.element.querySelector(fragments.SWIPER);
		this.swipers = new Swiper(this.swiperElement, {
			speed: 500,
			followFinger: false,
			simulateTouch: false,
			noSwiping: true,
			allowSlidePrev: false,
			allowSlideNext: false,
			slidesPerView: 20,
			watchOverflow: true,
			navigation: {
				nextEl: fragments.NEXT,
				prevEl: fragments.PREV,
			},
			breakpoints: {
				768: {
					noSwiping: false,
					slidesPerView: 2,
					allowSlidePrev: true,
					allowSlideNext: true,
				},
				992: {
					slidesPerView: dataSliderPerView,
					noSwiping: false,
					allowSlidePrev: true,
					allowSlideNext: true,
				},
			}
		});
	}
	willUnMount() {}
	update() {}
}
export default CardProductOverviewSlider;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/CardProductOverviewSlider.js